import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import Button, { ButtonProps } from '../../../antd/button';
import { execute } from '../../../../../utils/api/api-execute';
import EndPoints from '../../../../../services/end-points';
import { useNavigate } from 'react-router-dom';
import FormHookModal from '../../../../general/modals/form-hook-modal';
import { useModal } from 'react-modal-hook';
import { useState, useRef, useContext } from 'react';
import { IChatMessageRequest, ISendMessage } from '../../../../../models/chat/request';
import { MessageInput } from '../../../../order/send-message-form';
import { BsChatSquareText } from "react-icons/bs";
import ChatContext from '../../../../../context/chat/context';

interface Props extends ButtonProps {
    userId: number;
}

interface IMessageForm {
    message: string;
}


const ChatBtn: React.FC<Props> = ({ userId, ...props }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const chatIdRef = useRef<number | null>(null);
    const {actions:{sendMessage}}=useContext(ChatContext);
    const [showModal, hideModal] = useModal(() => (
        <FormHookModal<IMessageForm>
            id="first-message-form"
            title={t("write_first_message")}
            confirmButtonText={t("send")}
            loading={loading}
            onSubmit={handleSendMessage}
            hideModal={hideModal}
            defaultValues={{ message: "" }}
            width={600}
            style={{
                top: '30%',
              }}
        >
            <MessageInput />
        </FormHookModal>
    ));

    const createChat = async () => {
        await execute({
            callback: async () => {
                const response = await EndPoints.chat.createChat({ user_id: userId });
                const createdChatId = response?.data?.id;
                if (!response.data.new_chat){
                    navigate(`/chat?chatId=${createdChatId}`);
                }
                if (createdChatId) {
                    chatIdRef.current = createdChatId;
                    showModal();
                }
            },
            fallback: (error) => {
                console.error('Failed to create chat:', error);
            },
        });
    };

    const handleSendMessage = async (formData: IMessageForm) => {
        const chatId = chatIdRef.current;
        const trimmedMessage = formData.message.trim();

        if (!chatId || !trimmedMessage) return;

        setLoading(true);
        try {
            const data: IChatMessageRequest = {
                chatId,
                isAdmin: 1,
                body: trimmedMessage,
                file: null,
            };

            await sendMessage(data);

            navigate(`/chat?chatId=${chatId}`);
        } catch (error) {
            console.error('Failed to send first message:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title={t('chat')}>
            <Button
                shape="circle"
                icon={<BsChatSquareText />}
                onClick={createChat}
                {...props}
            />
        </Tooltip>
    );
};

export default ChatBtn;
